@let apiResponse = data();
@if (apiResponse) {
  <div class="flex flex-col h-full">
    <div class="ml-2 mt-2 mb-4 text-xl">
      <b>Samlet opkrævning:</b> {{ apiResponse.sum | number: '1.2' }}
    </div>
    <div class="flex-1 overflow-hidden">
      <p-table
        [value]="apiResponse.data"
        [loading]="leverandoerOpkraevningService.datasource.isLoading()"
        [showGridlines]="true"
        [scrollable]="true"
        scrollHeight="flex"
        stripedRows
        class="p-datatable-sm lp-table"
        selectionMode="single"
        [metaKeySelection]="true"
        (onRowSelect)="onRowSelect($event)"
        dataKey="id"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="onLazyLoad($event)"
        sortField="leverandoerOpkraevningPeriode.opkraevningsPeriodeFra"
        [sortOrder]="-1"
        [paginator]="true"
        [rows]="100"
        [totalRecords]="apiResponse.totalRowCount"
        [showJumpToPageDropdown]="true"
        letKeepScrollPosition>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="pengeinstitut.hovedRegNr">
              Regnr
              <p-sortIcon field="pengeinstitut.hovedRegNr" />
            </th>
            <th
              pSortableColumn="leverandoerOpkraevningPeriode.opkraevningsPeriodeFra">
              Periode
              <p-sortIcon
                field="leverandoerOpkraevningPeriode.opkraevningsPeriodeFra" />
            </th>
            <th pSortableColumn="udsendt">
              Udsendt
              <p-sortIcon field="udsendt" />
            </th>
            <th>Antal opkrævninger</th>
            <th>Sum</th>
            <th>Regneark</th>
          </tr>
        </ng-template>
        <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
          <tr [pSelectableRow]="item" class="cursor-pointer">
            <td>{{ item.pengeinstitut.regnr }}</td>
            <td class="numbers">
              {{
                item.leverandoerOpkraevningPeriode.opkraevningsPeriodeFra
                  | date: 'dd-MM-yyyy'
              }}
              -
              {{
                item.leverandoerOpkraevningPeriode.opkraevningsPeriodeTil
                  | date: 'dd-MM-yyyy'
              }}
            </td>
            <td class="numbers">{{ item.udsendt | date: 'dd-MM-yyyy' }}</td>
            <td class="numbers !text-right">
              {{ item.antalOpkraevninger | number: '1.0' }}
            </td>
            <td class="numbers !text-right">
              {{ item.sumOpkraevninger | number: '1.2' }}
            </td>
            <td>
              <i
                class="pi pi-file-excel cursor-pointer"
                (click)="exportData($event, item.id)"></i>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
